module.exports = __webpack_public_path__ + "static/media/30_tn.e2a7e3c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/30_tn.jpg
// module id = 168
// module chunks = 0